export default {
  install(Vue) {
    Vue.prototype.get_driver_license = async function() {
      const api = `${window.endpoints.api}/BasicInformation/DriverLicense`;
      const params = { IsEnable: true };

      const response = await this.$http.get(api, { params });
      return response.data;
    };
  }
};